<template>
  <div class="chartBox">
    <div
      class="leftBox"
      @click="leftBoxFn"
      v-show="isChartEdit && chartInfo.chartType === 1"
    ></div>
    <!-- 多选列表 -->
    <chart-list-tip
      class="chartLeftTip"
      v-show="isChartEdit && chartInfo.chartType === 1 && isChartListTip"
      :chartInfo="chartInfo"
    ></chart-list-tip>
    <chart-module :chartInfo="chartInfo"></chart-module>
    <div
      class="rightBox"
      @click="rightBoxFn"
      v-show="isChartEdit && chartInfo.chartType === 0"
    ></div>
    <!-- 多选列表 -->
    <chart-list-tip
      class="chartRightTip"
      v-show="isChartEdit && chartInfo.chartType === 0 && isChartListTip"
      :chartInfo="chartInfo"
    ></chart-list-tip>
  </div>
</template>

<script>
import chartModule from "@/module/chart.vue";
import chartListTip from "@/module/chartListTip.vue";
export default {
  props: ["chartData", "isEdit"],
  components: {
    chartModule,
    chartListTip,
  },
  data() {
    return {
      chartInfo: { headName: "", id: "" },
      isChartEdit: false, // 编辑模式
      isChartListTip: false, // 显示图标选择列表
      getDataInterval: null,
    };
  },
  mounted() {
    this.chartInfo = this.chartData;
    this.getDataInterval = setInterval(() => {
    this.chartInfo = this.chartData;
    }, 1000);
  },
  methods: {
    leftBoxFn() {
      this.isChartListTip = !this.isChartListTip;
    },

    rightBoxFn() {
      this.isChartListTip = !this.isChartListTip;
    },
  },

  watch: {
    isEdit(n) {
      this.isChartEdit = n;
      // 退出编辑模式后隐藏图标选择列表
      if (n === false) {
        this.isChartListTip = n;
      }
    },
    chartData:{
      handler(newValue,oldValue){
        this.chartInfo = newValue;
      }
    }
  },
  destroyed() {
    //清除定时器
    if (this.getDataInterval) clearInterval(this.getDataInterval);
  },
};
</script>
<style lang="less" scoped>
.chartBox {
  display: flex;
  position: relative;
  margin-top: 8px;

  .leftBox {
    width: 28px;
    height: 28px;
    background: url("../../images/edit.png") no-repeat 0 0;
    background-size: 100% 100%;
    margin-right: 10px;
    position: absolute;
    left: -40px;
    top: 34px;
    cursor: pointer;
  }
  .rightBox {
    width: 28px;
    height: 28px;
    background: url("../../images/edit.png") no-repeat 0 0;
    background-size: 100% 100%;
    margin-left: 10px;
    position: absolute;
    right: -40px;
    top: 34px;
    cursor: pointer;
  }
  .chartLeftTip {
    position: absolute;
    left: -244px;
    top: 34px;
  }
  .chartRightTip {
    position: absolute;
    right: -244px;
    top: 34px;
  }
}
</style>